import React from "react";
import { Text, useTheme, Image, Stack } from "@bookingcom/bui-react";
import Frame from "../../Frame/index.js";
import styles from "./FlightCardHighlight.module.css";
import useUserAgent from "../../../../hooks/useUserAgent.js";
import { useI18n } from "@bookingcom/lingojs-react";
import { t } from "@bookingcom/lingojs-core";
import FlightCardGeniusHighlightBottomSheetWrapper from "./GeniusPinning/FlightCardGeniusHighlightBottomSheetWrapper.js";
import FlightCardGeniusHighlightTooltipWrapper from "./GeniusPinning/FlightCardGeniusHighlightTooltipWrapper.js";
export const FlightCardHighlightStyle = {
    PRIMARY: "PRIMARY",
    CONSTRUCTIVE: "CONSTRUCTIVE",
    GENIUS: "GENIUS",
    NEUTRAL: "NEUTRAL"
};
export const FlightCardHighlight = ({ style = FlightCardHighlightStyle.PRIMARY, text, textEmphasized = false, showGeniusLogo = false, infoTooltip }) => {
    const { colors } = useTheme();
    const getBackgroundColor = (style) => {
        return style === FlightCardHighlightStyle.CONSTRUCTIVE
            ? colors.color_constructive_background_alt
            : style === FlightCardHighlightStyle.GENIUS
                ? colors.color_brand_genius_primary_background
                : style === FlightCardHighlightStyle.NEUTRAL
                    ? colors.color_background_base
                    : colors.color_action_background_alt;
    };
    const getForegroundColor = (style) => {
        return style === FlightCardHighlightStyle.CONSTRUCTIVE
            ? colors.color_constructive_foreground
            : style === FlightCardHighlightStyle.GENIUS
                ? colors.color_foreground_inverted
                : colors.color_brand_primary_foreground;
    };
    const getBorderColor = (style) => {
        return style === FlightCardHighlightStyle.NEUTRAL ? colors.color_border_alt : undefined;
    };
    const { isMobile } = useUserAgent();
    const i18n = useI18n();
    return (React.createElement(Frame, { alignItems: "center", direction: "row", justifyContent: "space-between", attributes: {
            style: { background: getBackgroundColor(style), borderBottom: `1px solid ${getBorderColor(style)}` }
        } },
        React.createElement(Stack, { direction: "row", alignItems: "center", className: styles.highlightText },
            showGeniusLogo && (React.createElement(Image, { asset: {
                    setName: "images-genius",
                    assetName: "GeniusLogo"
                }, height: "12px", alt: i18n.trans(t("a11y_genius_sr_pinned_deal")) })),
            React.createElement(Text, { variant: textEmphasized ? "emphasized_2" : "small_1", attributes: {
                    style: {
                        color: getForegroundColor(style),
                        background: getBackgroundColor(style)
                    }
                } }, text)),
        infoTooltip &&
            (isMobile ? (React.createElement(FlightCardGeniusHighlightBottomSheetWrapper, { infoTooltip: infoTooltip })) : (React.createElement(FlightCardGeniusHighlightTooltipWrapper, { infoTooltip: infoTooltip })))));
};
